<template>
  <div :class="'mark '+rootClass" ref="root">
    <div class="mark-anim">
      <div :class="'brown-title-bg '+titleClass"></div>
      <img :class="'brown-gear '+brownGearClass" src="../../assets/Main/SubSection/gear_brown.png">
      <img :class="'green-gear '+greenGearClass" ref="markHeightRef" id="mark-height-ref" src="../../assets/Main/SubSection/gear_green.png">
      <img :class="'title '+titleClass" :src="titleImgSrc">
      <img :class="'hane '+haneClass" src="../../assets/Main/SubSection/hane.png">
      <div :class="'bar '+barClass"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionTitle",
  data() {
    return {
      rootClass: "invisible",
      titleClass: "invisible",
      haneClass: "invisible",
      barClass: "invisible",
      brownGearClass: "invisible",
      greenGearClass: "invisible",
      isGoingToVisible: 0,
      isGoingToInvisible: 0,
      disableHide: false
    };
  },
  props: ["titleImgName"],
  methods: {
    showCallback() {
      if (window.innerWidth <= 768) {
        this.disableHide = true;
      } else {
        this.disableHide = false;
      }
      this.isGoingToVisible++;
      this.rootClass = "visible";
      this.haneClass = "visible";
      this.barClass = "visible";
      this.brownGearClass = "visible";
      this.greenGearClass = "visible";
      // 消えかけのときは遅延なしで再表示
      if (this.isGoingToInvisible != 0) {
        this.titleClass = "visible";
      }
      setTimeout(() => {
        // 遅延でタイトル表示
        if (this.isGoingToInvisible == 0) {
          this.titleClass = "visible";
        }
        this.isGoingToVisible--;
      }, 700);
    },
    hideCallback() {
      if (this.disableHide) {
        return;
      }
      this.isGoingToInvisible++;

      this.rootClass = "invisible";
      this.titleClass = "invisible";
      // 羽とバーはその位置のまま消える
      this.haneClass = "to-invisible";
      this.barClass = "to-invisible";
      this.brownGearClass = "invisible";
      this.greenGearClass = "invisible";
      setTimeout(() => {
        // 再表示しようとしていなければ位置を右側にリセット
        if (this.isGoingToVisible == 0) {
          this.haneClass = "invisible";
          this.barClass = "invisible";
        }
        this.isGoingToInvisible--;
      }, 700);
    },
    onDisplayed() {
      const $ = require("jquery");
      // markの高さを0でなくする
      var heightRef = $(this.$refs.markHeightRef);
      this.$refs.root.style.height = heightRef.outerHeight(true) + "px";
      window.addEventListener("resize", () => {
        this.$refs.root.style.height = heightRef.outerHeight(true) + "px";
      });
    }
  },
  computed: {
    titleImgSrc: function() {
      return require("../../assets/Main/SubSection/" + this.titleImgName);
    }
  }
};
</script>

<style lang="scss" scoped>
.mark {
  position: relative;
  width: 100%;
  filter: drop-shadow(1px 1px 10px rgba(0, 0, 0, 0.7));
  animation: horizontal 2s ease-in-out infinite alternate;
}

.mark-anim {
  width: 100%;
  height: 100%;
  animation: vertical 3s ease-in-out infinite alternate;
}

@keyframes horizontal {
  0% {
    transform: translateX(-2px);
  }
  100% {
    transform: translateX(2px);
  }
}

@keyframes vertical {
  0% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(5px);
  }
}

.brown-gear {
  position: absolute;
  width: 60%;
  left: 0%;
  margin-top: 35%;
  &.visible {
    transform: rotate(0deg);
  }
  &.invisible {
    transform: rotate(180deg);
  }
}

.green-gear {
  position: absolute;
  width: 40%;
  margin-left: 40%;
  margin-top: 55%;
  &.visible {
    transform: rotate(0deg);
  }
  &.invisible {
    transform: rotate(-180deg);
  }
}

.title {
  position: absolute;
  width: 70%;
  margin-left: 30%;
  margin-top: 70%;
  color: #f8f3d9;
  transition: 0.7s ease;
  &.visible {
    opacity: 1;
  }
  &.invisible {
    opacity: 0;
  }
}

.brown-title-bg {
  position: absolute;
  width: 30%;
  height: 20%;
  margin-left: 73%;
  margin-top: 68%;
  background-color: #665349;
  color: #f8f3d9;
  transition: opacity 0.7s ease;
  &.visible {
    opacity: 1;
  }
  &.invisible {
    opacity: 0;
  }
}

.hane {
  position: absolute;
  width: 70%;
  margin-left: 30%;
  transition: 0.7s ease;
  &.visible {
    opacity: 1;
  }
  &.to-invisible {
    opacity: 0;
  }
  &.invisible {
    transition: 0s ease;
    opacity: 0;
    margin-left: 100%;
  }
}

.bar {
  position: absolute;
  background: #f8f3d9;
  height: 2px;
  width: 70%;
  margin-top: 80%;
  margin-left: 30%;
  transition: 0.7s ease;
  &.visible {
    opacity: 1;
  }
  &.to-invisible {
    opacity: 0;
  }
  &.invisible {
    transition: 0s ease;
    opacity: 0;
    margin-left: 100%;
    width: 0;
  }
}

.visible {
  transition: 0.7s ease;
  opacity: 1;
}

.invisible {
  transition: 0.7s ease;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Parts/SectionTitle.vue